<template>
  <div>
    <van-cell-group title="新单据">
      <van-cell title="添加申请" is-link size="large" :to="`/apply/list/${formKey}/add`"/>
    </van-cell-group>
    <van-cell-group title="处理与查询">
      <van-cell title="我的申请" is-link size="large" :to="`/apply/list/${formKey}/mine`"/>
      <van-cell title="我的审批" is-link size="large" :to="`/apply/list/${formKey}/sp`"><span style="color: red;">{{ spcount }}</span></van-cell>
      <van-cell title="所有申请" is-link size="large" :to="`/apply/list/${formKey}/all`"/>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return{
      formKey:this.$route.params.formKey,
      spcount:0,
      queryData: {
        formKey: this.$route.params.formKey,
      },
    }
  },
  created() {
    this.init();
  },
  methods: {    
    init() {
      this.getCount();
    },
    getCount() {
      let self = this;
      this.whale.remote.getResult({
        url: "/api/api/flow-form-data/apply-count",
        data: this.queryData,
        completed: function ({ ResultType, Message, AppendData }) {
          if (ResultType == 0) {
            self.spcount = AppendData;
          } else {
            Toast.fail(Message);
          }
        },
      });
    },
  }
}
</script>

<style scoped>

</style>